(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/views/about.js') >= 0) return;  svs.modules.push('/modules/player-login/views/about.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_login=_svs.player_login||{};
_svs.player_login.templates=_svs.player_login.templates||{};
svs.player_login.templates.about = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p>\n  Logga in enkelt och säkert på Svenska Spel Sport &amp; Casino med \n  BankID eller Freja eID. Båda är elektroniska ID-handlingar som är jämförbara med pass, \n  körkort och andra fysiska legitimationer.\n</p>\n\n<b>Saknar du e-legitimation?</b>\n<p>\n  Beställ BankID hos din bank eller ladda ner Freja-appen gratis från Appstore, \n  Google Play eller AppGallery.\n</p>\n  \n<b>Behöver du hjälp?</b>\n<p>Ring oss på 0770 - 11 11 11</p>\n";
},"useData":true});
Handlebars.partials['svs-player_login-about'] = svs.player_login.templates.about;
})(svs, Handlebars);


 })(window);